import React, { useEffect, useRef, useState } from 'react';

import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";

const MultiplicationQuizGame = () => {
  const multipliers = [5, 9, 10, 11, 25, 50];
  const [currentAnswer, setCurrentAnswer] = useState(null);
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [score, setScore] = useState(0);
  const [questionText, setQuestionText] = useState('Loading...');
  const [options, setOptions] = useState([]);
  const [resultText, setResultText] = useState('');
  const [resultColor, setResultColor] = useState('');
  const [disableButtons, setDisableButtons] = useState(false);
  const mainRef = useRef(null);
  const correctSoundRef = useRef(null);
  const wrongSoundRef = useRef(null);

  useEffect(() => {
    if (window.speechSynthesis.getVoices().length === 0) {
      window.speechSynthesis.onvoiceschanged = generateQuestion;
    } else {
      generateQuestion();
    }
  }, []);

  const speakQuestion = (text) => {
    if (!window.speechSynthesis) return;
    window.speechSynthesis.cancel();
    const voice = new SpeechSynthesisUtterance(text);
    voice.pitch = 1.3;
    voice.rate = 0.95;
    const voices = window.speechSynthesis.getVoices();
    voice.voice = voices.find(v => v.lang.includes('en') && v.name.includes('Google')) || voices[0];
    window.speechSynthesis.speak(voice);
  };

  const generateQuestion = () => {
    const multiplier = multipliers[Math.floor(Math.random() * multipliers.length)];
    const num = Math.floor(Math.random() * 12) + 1;
    const answer = num * multiplier;
    setCurrentAnswer(answer);
    setQuestionText(`${num} × ${multiplier} = ?`);
    speakQuestion(`What is ${num} times ${multiplier}?`);
    setResultText('');
    setResultColor('');
    setDisableButtons(false);
    generateOptions(answer);
    setTotalQuestions(prev => prev + 1);
  };

  const generateOptions = (correct) => {
    let optionsSet = new Set([correct]);
    while (optionsSet.size < 4) {
      let wrong = correct + Math.floor(Math.random() * 20 - 10);
      if (wrong > 0) optionsSet.add(wrong);
    }
    setOptions(Array.from(optionsSet).sort(() => 0.5 - Math.random()));
  };

  const createConfetti = () => {
    for (let i = 0; i < 15; i++) {
      const confetti = document.createElement('div');
      confetti.style.position = 'absolute';
      confetti.style.width = '10px';
      confetti.style.height = '10px';
      confetti.style.borderRadius = '50%';
      confetti.style.backgroundColor = `hsl(${Math.random() * 360}, 100%, 70%)`;
      confetti.style.left = `${Math.random() * 100}%`;
      confetti.style.animation = `confettiFall ${2 + Math.random() * 2}s linear ${i * 0.1}s forwards`;
      confetti.style.pointerEvents = 'none';
      confetti.style.zIndex = 10;
      mainRef.current.appendChild(confetti);
      setTimeout(() => confetti.remove(), 4000);
    }
  };

  const checkAnswer = (selected) => {
    setDisableButtons(true);
    if (selected === currentAnswer) {
      setScore(prev => prev + 1);
      setResultText('🎉 Correct! Great job!');
       const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
      setResultColor('#2ecc40');
      correctSoundRef.current.play();
      createConfetti();
    } else {
      setResultText(`❌ Oops! The correct answer was ${currentAnswer}.`);
      setResultColor('#e74c3c');
      wrongSoundRef.current.play();
    }
    setTimeout(() => generateQuestion(), 2500);
  };

  return (
    <div style={{
      fontFamily: "'Comic Neue', cursive, sans-serif",
      margin: 0,
      background: 'linear-gradient(135deg, #fceabb, #f8b500)',
      color: '#001858',
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '5vw'
    }}>
      <header style={{
        background: '#f582ae',
        color: 'white',
        width: '100%',
        padding: '1.5rem',
        textAlign: 'center',
        fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
        fontWeight: 900,
        textShadow: '1px 1px 3px #6b1147',
        borderRadius: '15px 15px 0 0',
        boxShadow: '0 6px 12px rgba(0,0,0,0.1)',
        userSelect: 'none'
      }}>🎯 Multiplication Quiz Game 🎯</header>
      {/* <div style={{
          fontSize: '10vw',
          marginBottom: '0.2rem',
          userSelect: 'none',
          animation: 'bounce 1.5s infinite alternate'
        }} aria-label="Wizard Wally">🧙‍♂️</div> */}

      <main ref={mainRef} style={{
        background: 'white',
        borderRadius: '25px',
        padding: '2rem',
        boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
        maxWidth: '90vw',
        width: '100%',
        marginTop:'10%',
        maxWidth: '480px',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}>
        

        <div style={{
          fontSize: 'clamp(1.2rem, 5vw, 2rem)',
          marginBottom: '1rem',
          fontWeight: 100,
          color: '#f582ae',
          textShadow: '1px 1px 4px #c3566f'
        }}>{questionText}</div>

        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '1rem',
          marginBottom: '1.5rem'
        }}>
          {options.map((opt, idx) => (
            <button key={idx}
              onClick={() => checkAnswer(opt)}
              disabled={disableButtons}
              aria-label={`Answer option ${opt}`}
              style={{
                backgroundColor: '#8bd3dd',
                border: 'none',
                padding: '1rem',
                fontSize: 'clamp(1rem, 4vw, 1.4rem)',
                borderRadius: '15px',
                cursor: 'pointer',
                boxShadow: '0 6px #5aa9a8',
                color: '#003f4f',
                fontWeight: 700,
                userSelect: 'none',
                width: '40%',
                maxWidth: '120px',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease'
              }}>
              {opt}
            </button>
          ))}
        </div>

        <div style={{
          fontWeight: 900,
          fontSize: 'clamp(1rem, 3.5vw, 1.5rem)',
          minHeight: '2rem',
          marginBottom: '1rem',
          color: resultColor,
          transition: 'opacity 0.4s ease'
        }} aria-live="polite">{resultText}</div>

        <div style={{
          fontSize: 'clamp(1rem, 3vw, 1.2rem)',
          fontWeight: 700,
          marginBottom: '1rem',
          color: '#f582ae',
          userSelect: 'none'
        }}>
          Score: {score} / {totalQuestions}
        </div>
      </main>

      <audio ref={correctSoundRef} src="https://actions.google.com/sounds/v1/cartoon/clang_and_wobble.ogg" preload="auto" />
      <audio ref={wrongSoundRef} src="https://actions.google.com/sounds/v1/cartoon/wood_plank_flicks.ogg" preload="auto" />

      <style>{`
        @keyframes bounce {
          0% { transform: translateY(0);}
          100% { transform: translateY(-15px);}
        }
        @keyframes confettiFall {
          0% {transform: translateY(0) rotate(0deg);}
          100% {transform: translateY(400px) rotate(360deg);}
        }
      `}</style>
    </div>
  );
};

export default MultiplicationQuizGame;
